import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const RaiseModalHost = styled.div`
  position: relative;
  z-index: 99998;
`

export const ItemLineCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
`

export const ItemLineMeta = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
  font-variant-numeric: tabular-nums;
`
